module.exports = __webpack_public_path__ + "static/img/loginButton.23f025ac.png";